<template>
	<div class="cart-totals" :class="simple && 'ww-totals'">
		<BaseWebshopTotal v-slot="{items}">
			<template v-if="items">
				<div class="c-total-cnt cart-total-without-discount cart_info_total_items_basic_without_discount_box" v-show="items.total_items_basic_without_discount">
					<span class="w-totals-label"><BaseCmsLabel code="total_minus_discount" default="Ukupno bez popusta" />:</span>
					<span class="w-totals-value cart_info_total_items_basic_without_discount"><BaseUtilsFormatCurrency :price="items.total_items_basic_without_discount" /></span>
				</div>
				<div class="c-total-cnt cart-total-discount cart_info_total_items_basic_discount_box" v-if="items.total_items_basic_discount">
					<span class="w-totals-label"><BaseCmsLabel code="total_discount" default="Popust" />:</span>
					<span class="w-totals-value cart_info_total_items_basic_discount"><BaseUtilsFormatCurrency :price="items.total_items_basic_discount" /></span>
				</div>
				<div class="c-total-cnt cart-total-without-tax" v-if="items.total_items_basic">
					<span class="w-totals-label"><BaseCmsLabel code="total_minus_tax" default="Ukupno s popustom" />:</span>
					<span class="w-totals-value cart_info_total_items_basic"><BaseUtilsFormatCurrency :price="items.total_items_basic" /></span>
					<small v-if="items.total_basic_taxranks_description" class="cart_info_total_basic_taxranks_description" v-html="items.total_basic_taxranks_description" />
				</div>
				<div class="c-total-cnt cart-total-tax" v-if="items.total_items_tax">
					<span class="w-totals-label"><BaseCmsLabel code="total_tax" default="PDV" />:</span>
					<span class="w-totals-value cart_info_total_items_tax"><BaseUtilsFormatCurrency :price="items.total_items_tax" /></span>
					<small v-if="items.total_tax_taxranks_description" class="cart_info_total_tax_taxranks_description" v-html="items.total_tax_taxranks_description" />
				</div>
				<div class="c-total-cnt cart_info_total_extra_extraitem_priority_order_box" v-if="(priorityItem = items.extraitems.find(el => el.type == 'extraitem_priority_order' && el.total > 0))">
					<span class="w-totals-label"><BaseCmsLabel code="priority_order_title" default="Prioritetna narudžba" />:</span>
					<span class="w-totals-value cart_info_total_extra_extraitem_priority_order"><BaseUtilsFormatCurrency :price="priorityItem.total" /></span>
				</div>
				<div class="c-total-cnt cart-total-without-shipping cart-total-shipping" v-if="items.total_items_total">
					<span class="w-totals-label"><BaseCmsLabel code="total_minus_shipping" default="Ukupno bez dostave" />:</span>
					<span class="w-totals-value value cart_info_total_items_total"> <BaseUtilsFormatCurrency :price="items.total_items_total" /> </span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_discount_box" v-if="items.total_extra_discount">
					<span class="w-totals-label"><BaseCmsLabel code="discount" default="Popust" />:</span>
					<span class="w-totals-value cart_info_total_extra_discount"><BaseUtilsFormatCurrency :price="items.total_extra_discount" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_coupon_box" v-if="items.total_extra_coupon">
					<span class="w-totals-label"><BaseCmsLabel code="coupon" default="Kupon" />:</span>
					<span class="w-totals-value cart_info_total_extra_coupon"> <BaseUtilsFormatCurrency :price="items.total_extra_coupon" /> </span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_coupon_product_box" v-if="items.total_extra_coupon_product">
					<span class="w-totals-label"><BaseCmsLabel code="coupon_product" default="Kupon" />:</span>
					<span class="w-totals-value cart_info_total_extra_coupon_product"><BaseUtilsFormatCurrency :price="items.total_extra_coupon_product" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_affiliate_box" v-if="items.total_extra_affiliate">
					<span class="w-totals-label"><BaseCmsLabel code="affiliate" />:</span>
					<span class="w-totals-value cart_info_total_extra_affiliate"><BaseUtilsFormatCurrency :price="items.total_extra_affiliate" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_abandonment_box" v-if="items.total_extra_abandonment">
					<span class="w-totals-label"><BaseCmsLabel code="abandonment" />:</span>
					<span class="w-totals-value cart_info_total_extra_abandonment"><BaseUtilsFormatCurrency :price="items.total_extra_abandonment" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_loyalty_box cart-loyalty-box" v-if="items.total_extra_loyalty">
					<span class="w-totals-label">
						<BaseCmsLabel code="loyalty" default="Kartica kupca" />
						<span class="cart_info_total_extra_loyalty_discount_percent">{{' '+items.total_extra_loyalty_discount_percent}}</span>%:
					</span>
					<span class="w-totals-value cart_info_total_extra_loyalty"><BaseUtilsFormatCurrency :price="items.total_extra_loyalty" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_cc_discount_box" v-if="items.total_extra_cc_discount">
					<span class="w-totals-label"><BaseCmsLabel code="cc_discount" />:</span>
					<span class="w-totals-value cart_info_total_extra_cc_discount"><BaseUtilsFormatCurrency :price="items.total_extra_cc_discount" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_cover_box" v-if="items.total_extra_cover">
					<span class="w-totals-label"><BaseCmsLabel code="cover" />:</span>
					<span class="w-totals-value cart_info_total_extra_cover"><BaseUtilsFormatCurrency :price="items.total_extra_cover" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_relatedlist_box" v-if="items.total_extra_relatedlist">
					<span class="w-totals-label"><BaseCmsLabel code="relatedlist" />:</span>
					<span class="w-totals-value cart_info_total_extra_relatedlist"><BaseUtilsFormatCurrency :price="items.total_extra_relatedlist" /></span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_supplement_box" v-if="items.total_extra_supplement">
					<span class="w-totals-label"><BaseCmsLabel code="supplement" />:</span>
					<span class="w-totals-value cart_info_total_extra_supplement"><BaseUtilsFormatCurrency :price="items.total_extra_supplement" /></span>
				</div>
				<div class="c-total-cnt cart-total-shipping">
					<span class="w-totals-label"><BaseCmsLabel code="shipping" default="Dostava" />:</span>
					<span class="w-totals-value cart_info_total_extra_shipping">
						<template v-if="items.total_extra_shipping == 0">
							<BaseCmsLabel code="free" />
						</template>
						<template v-else>
							<BaseUtilsFormatCurrency :price="items.total_extra_shipping" />
						</template>
					</span>
				</div>
				<div class="c-total-cnt cart_info_total_extra_payment_box" v-if="items.total_extra_payment">
					<span class="w-totals-label"><BaseCmsLabel code="additional_payment" default="Dodatna naplata" />:</span>
					<span class="w-totals-value cart_info_total_extra_payment"><BaseUtilsFormatCurrency :price="items.total_extra_payment" /></span>
				</div>
				<div class="c-total-cnt cart-total" v-if="items.total">
					<span class="w-totals-label"><BaseCmsLabel code="total" default="Ukupno za platiti" />:</span>
					<span class="w-totals-value value cart_info_total"><BaseUtilsFormatCurrency :price="items.total" /></span>
				</div>
			</template>
		</BaseWebshopTotal>
	</div>
</template>

<script setup>
	const props = defineProps(['simple', 'mode']);
</script>

<style lang="less" scoped>
	.c-total-cnt{display: flex; flex-flow: row; justify-content: space-between; align-items: center;}
	.cart-total{display: flex; justify-content: space-between; align-items: center;}
	.cart-total-without-tax,.cart-total-tax{
		small{display: none;}
	}
	.w-totals-label{font-size: 18px; line-height: 28px; font-weight: 300;}
	.w-totals-value{float: right; font-size: 18px; line-height: 28px; font-weight: 300;}
	.cart-total{
		.w-totals-label, .w-totals-value{font-weight: bold; color: var(--primaryColor);}
	}

	@media (max-width: @l){
		.w-totals-label,.w-totals-value{font-size: 17px; line-height: 28px;}
	}
	@media (max-width: @t){
		.w-totals-label{font-size: 14px; line-height: 24px;}
		.w-totals-value{font-size: 14px; line-height: 24px;}
	}
	@media (max-width: @m){
		.w-totals-label, .w-totals-value{font-size: 14px; line-height: 24px;}
	}

	//checkout
	.ww-totals{
		padding: 16px 40px 16px 165px; border: 1px solid var(--borderColor); border-left: unset; border-right: unset; margin-top: -1px; background: white;
		.c-total-cnt{display: flex;}
		.cart-total-discount,.cart-total-without-discount,.cart_info_total_extra_coupon_product_box,.cart_info_total_extra_abandonment_box,.cart-total-without-tax,.cart-total-tax,.cart-total-without-shipping,.total_extra_payment_box{display: none !important;}
		.cart_info_total_extra_coupon_box{display: flex;}
		.w-totals-label{font-size: 16px; line-height: 22px;}
		.w-totals-value{font-size: 16px; line-height: 22px; text-align: right;}
		.cart-total{padding: 0; margin: 0; border-top: 0;}
		@media (max-width: @t){
			padding: 16px 30px 16px 30px;
			.w-totals-label,.w-totals-value{font-size: 16px; line-height: 22px;}
		}
		@media (max-width: @tp){
			padding: 10px 15px;
			.w-totals-label{text-align: left; min-width: unset;}
			.w-totals-label,.w-totals-value{font-size: 14px; line-height: 20px;}
		}
	}
</style>
